import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetPriceComponents } from './priceComponentsThunk';
import { IPriceComponent, IPriceComponentList } from '~/utils/interface/estimate';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

export interface PriceComponentState {
  selectPriceComponents: Array<IPriceComponentList>;
  filter: IPriceComponentFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  priceComponents: Array<IPriceComponentList>;
  selectedPriceComponents: Array<IPriceComponent>;
  selectedIds: Array<string>;
  priceComponentId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IPriceComponentFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: PriceComponentState = {
  selectPriceComponents: [],
  selectedPriceComponents: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  priceComponents: [],
  priceComponentId: '',
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const priceComponentSlice = createSlice({
  name: 'priceComponent',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IPriceComponentFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changePriceComponentId(state, action: PayloadAction<string>) {
      state.priceComponentId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetPriceComponents.pending, (_state, _action) => {})

      .addCase(handleGetPriceComponents.fulfilled, (state, action) => {
        state.priceComponents = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.selectedPriceComponents = [...action.payload.responses];
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })

      .addCase(handleGetPriceComponents.rejected, (_state, _action) => {});
  },
});

export const priceComponentActions = priceComponentSlice.actions;

const priceComponentReducer = priceComponentSlice.reducer;
export default priceComponentReducer;
